"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var shared_module_1 = require("../shared.module");
var common_1 = require("@angular/common");
/**
 * Use this namespace for importing Authentication's service HttpAuthenticationService
 * (there is typo in idm-authentication-client-js package http authentication service name
 * HttpAuthorizationService must be HttpAuthenticationService)
 */
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var system_logout_handler_1 = require("../../system-logout-handler");
var token_expiration_service_1 = require("../login/token-expiration-manager/token-expiration.service");
var http_1 = require("@angular/common/http");
var loading_spinner_module_1 = require("../loading-spinner/loading-spinner.module");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var login_service_1 = require("../../services/login.service");
var idm_policy_client_js_1 = require("@synisys/idm-policy-client-js");
var user_session_identity_intercepter_1 = require("../../services/user-session-identity.intercepter");
function authServiceFactory(http, appProperties, cookieService) {
    return idm_authentication_client_js_1.CookieBasedAuthenticationService.getInstance(http, appProperties, cookieService);
}
exports.authServiceFactory = authServiceFactory;
/**
 * General module for providing HTTP implementations of services that are needed everywhere (e.g. login, shell)
 */
var MainOnlineProvidersModule = /** @class */ (function () {
    function MainOnlineProvidersModule() {
    }
    MainOnlineProvidersModule = __decorate([
        core_1.NgModule({
            imports: [shared_module_1.SharedModule, common_1.CommonModule, loading_spinner_module_1.LoadingSpinnerModule, idm_message_language_service_client_js_1.MessageLanguageApiModule],
            providers: [
                idm_authentication_client_js_1.CookieService,
                idm_um_permission_client_js_1.HttpPermissionConfigurationService,
                system_logout_handler_1.SystemLogoutHandler,
                token_expiration_service_1.TokenExpirationService,
                login_service_1.LoginService,
                idm_authentication_client_js_1.HttpClientWrapper,
                idm_authentication_client_js_1.TokenInfoService,
                idm_authentication_client_js_1.UnauthorizedInterceptor,
                idm_authentication_client_js_1.AuthTokenInterceptor,
                user_session_identity_intercepter_1.UserSessionIdentityIntercepter,
                { provide: idm_application_properties_service_client_js_1.ApplicationPropertiesService, useClass: idm_application_properties_service_client_js_1.HttpApplicationPropertiesService },
                { provide: idm_authorization_client_js_1.AuthorizationService, useClass: idm_authorization_client_js_1.HttpAuthorizationService },
                { provide: idm_locale_service_client_js_1.LocaleService, useClass: idm_locale_service_client_js_1.HttpLocaleService },
                { provide: idm_um_permission_client_js_1.PermissionConfigurationService, useClass: idm_um_permission_client_js_1.HttpPermissionConfigurationService },
                { provide: http_1.HTTP_INTERCEPTORS, useExisting: idm_authentication_client_js_1.UnauthorizedInterceptor, multi: true },
                { provide: http_1.HTTP_INTERCEPTORS, useExisting: idm_authentication_client_js_1.AuthTokenInterceptor, multi: true },
                { provide: http_1.HTTP_INTERCEPTORS, useExisting: user_session_identity_intercepter_1.UserSessionIdentityIntercepter, multi: true },
                { provide: idm_policy_client_js_1.PolicyService, useClass: idm_policy_client_js_1.PolicyHttpService },
                {
                    provide: idm_authentication_client_js_1.AuthenticationService,
                    useFactory: authServiceFactory,
                    deps: [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService, idm_authentication_client_js_1.CookieService]
                },
            ],
            exports: [loading_spinner_module_1.LoadingSpinnerModule]
        })
    ], MainOnlineProvidersModule);
    return MainOnlineProvidersModule;
}());
exports.MainOnlineProvidersModule = MainOnlineProvidersModule;
//# sourceMappingURL=main-online-providers.module.js.map